import axios from 'axios';
import s from '../store/index'

const _baseUrl = process.env.VUE_APP_API;
const _appId = process.env.VUE_APP_APPID;
const _secret = process.env.VUE_APP_SECRET;
const _deliverBaseUrl = process.env.VUE_APP_API3;

export default {
    getRoute(json) {
        let url = `${_baseUrl}dzyc-common/common/getRoute`;
        return axios.post(url, json).then(res => res.data);
    },


    //不需要token
    login(json) {
        let url = localStorage.getItem("cang.base.url") + `/cang/customerLogin`;
        return axios.post(url, json).then(res => res.data);
    },

    doLoginwx(json) {
        let url = `${_deliverBaseUrl}common/doLoginwx`;
        return axios.post(url, json).then(res => res.data);
    },


    selSysMessageCount(param) {
        let url = localStorage.getItem("cang.base.url") + `/sys/message/selSysMessageCount`;
        return axios.post(url, param, {headers: {'X-Merchant-Token': s.state.token}})
    },


    getOpenId(json) {
        let url = `https://api.weixin.qq.com/sns/oauth2/access_token?appid=${_appId}&secret=${_secret}&code=${json}&grant_type=authorization_code`;
        return axios.post(url).then(res => res.data);
    },

    getUeserOpenId(json) {
        let url = localStorage.getItem("cang.base.url") + `/cang/getUeserOpenId`;
        return axios.post(url, json).then(res => res.data);
    },

    getDeliverUeserOpenId(json) {
        let url = `${_deliverBaseUrl}common/getDeliverUeserOpenId`;
        return axios.post(url, json).then(res => res.data);
    },

    getUeserOpenIdNew(json) {
        let url = `${_deliverBaseUrl}wechat/getOpenid`;
        return axios.post(url, json).then(res => res.data);
    },


    registerCon(json) {
        let url = `${_deliverBaseUrl}deliver/registerCon`;
        return axios.post(url, json).then(res => res.data);
    },

    getRegisterCode(json) {
        let url = `${_baseUrl}consignor/getRegisterCode`;
        return axios.post(url, json).then(res => res.data);
    },

    getLoginCode(json) {
        let url = `${_baseUrl}dzyc-common/sms/sendSms`;
        return axios.post(url, json).then(res => res.data);
    },

    getThLoginCode(json) {
        let url = `${_deliverBaseUrl}/sms/getThLoginCode`;
        return axios.post(url, json).then(res => res.data);
    },

    getThRegCode(json) {
        let url = `${_deliverBaseUrl}/sms/getThRegCode`;
        return axios.post(url, json).then(res => res.data);
    },

    changeUserV2(json) {
        let url = `${_deliverBaseUrl}deliver/changeUser`;
        return axios.post(url, json, {headers: {'X-Merchant-Token': s.state.token}}).then(res => res.data);
    },

    getCustomerLoginCode(json) {
        let url = localStorage.getItem("cang.base.url") + `cang/getSmsCode`;
        return axios.post(url, json).then(res => res.data);
    },

    getOutType(json) {
        let url = localStorage.getItem("cang.base.url") + `pick/getOutType`;
        return axios.post(url, json, {headers: {'X-Merchant-Token': s.state.token}}).then(res => res.data);
    },

    getTruckList(json) {
        let url = localStorage.getItem("cang.base.url") + `wxdelivery/list`;
        return axios.post(url, json, {headers: {'X-Merchant-Token': s.state.token}}).then(res => res.data);
    },

    insertTruck(json) {
        let url = localStorage.getItem("cang.base.url") + `wxdelivery/insert`;
        return axios.post(url, json, {headers: {'X-Merchant-Token': s.state.token}}).then(res => res.data);
    },
    updateTruck(json) {
        let url = localStorage.getItem("cang.base.url") + `wxdelivery/update`;
        return axios.post(url, json, {headers: {'X-Merchant-Token': s.state.token}}).then(res => res.data);
    },
    deleteTruck(json) {
        let url = localStorage.getItem("cang.base.url") + `wxdelivery/delete`;
        return axios.post(url, json, {headers: {'X-Merchant-Token': s.state.token}}).then(res => res.data);
    },
    ladingBillList(json) {
        let url = localStorage.getItem("cang.base.url") + `wxdelivery/ladingList`;
        return axios.post(url, json, {headers: {'X-Merchant-Token': s.state.token}}).then(res => res.data);
    },
    ladingBillDetail(json) {
        let url = localStorage.getItem("cang.base.url") + `wxdelivery/ladingDetail`;
        return axios.post(url, json, {headers: {'X-Merchant-Token': s.state.token}}).then(res => res.data);
    },
    getWarrantyBookList(json) {
        let url = localStorage.getItem("cang.base.url") + `wxdelivery/searchWarrantyBookList`;
        return axios.post(url, json, {headers: {'X-Merchant-Token': s.state.token}}).then(res => res.data);
    },
    getWxconfig(json) {
        let url = `${_deliverBaseUrl}wechat/getConfig`;
        return axios.post(url, json, {headers: {'X-Merchant-Token': s.state.token}}).then(res => res.data);
    },


    getWxUser(json) {
        let url = `${_deliverBaseUrl}wechat/getWxUser`;
        return axios.post(url, json, {headers: {'X-Merchant-Token': s.state.token}}).then(res => res.data);
    },

    changeUser(json) {
        let url = `${_deliverBaseUrl}wechat/changeUser`;
        return axios.post(url, json, {headers: {'X-Merchant-Token': s.state.token}}).then(res => res.data);
    },

    getWxUserCode(json) {
        let url = `${_deliverBaseUrl}wechat/getWxUserCode`;
        return axios.post(url, json, {headers: {'X-Merchant-Token': s.state.token}}).then(res => res.data);
    },

    OutPerson(json) {
        let url = localStorage.getItem("cang.base.url") + `/wxdelivery/list`;
        return axios.post(url, json, {headers: {'X-Merchant-Token': s.state.token}}).then(res => res.data);
    },

    addOutTruk(json) {
        let url = localStorage.getItem("cang.base.url") + `/wxout/addTruckproveByDelivery`;
        return axios.post(url, json, {headers: {'X-Merchant-Token': s.state.token}}).then(res => res.data);
    },


    searchTruckproveListByDelivery(json) {
        let url = localStorage.getItem("cang.base.url") + `/wxout/searchTruckproveListByDelivery`;
        return axios.post(url, json, {headers: {'X-Merchant-Token': s.state.token}}).then(res => res.data);
    },

    delTruckprove(json) {
        let url = localStorage.getItem("cang.base.url") + `/wxout/delTruckprove`;
        return axios.post(url, json, {headers: {'X-Merchant-Token': s.state.token}}).then(res => res.data);
    },

    selTruckproveNotify(json) {
        let url = localStorage.getItem("cang.base.url") + `/wxout/selTruckproveNotify`;
        return axios.post(url, json, {headers: {'X-Merchant-Token': s.state.token}}).then(res => res.data);
    },

    selTruckproveOut(json) {
        let url = localStorage.getItem("cang.base.url") + `/wxout/selTruckproveOut`;
        return axios.post(url, json, {headers: {'X-Merchant-Token': s.state.token}}).then(res => res.data);
    },
    selOuCargoG(json) {
        let url = localStorage.getItem("cang.base.url") + `/cang/sys/cargo/selOuCargoG`;
        return axios.post(url, json, {headers: {'X-Merchant-Token': s.state.token}}).then(res => res.data);
    },

    selCargoMaterialG(json) {
        let url = localStorage.getItem("cang.base.url") + `/cang/material/selCargoMaterialG`;
        return axios.post(url, json, {headers: {'X-Merchant-Token': s.state.token}}).then(res => res.data);
    },
    selCargoModelG(json) {
        let url = localStorage.getItem("cang.base.url") + `/cang/model/selCargoModelG`;
        return axios.post(url, json, {headers: {'X-Merchant-Token': s.state.token}}).then(res => res.data);
    },
    selCargoOriginG(json) {
        let url = localStorage.getItem("cang.base.url") + `/cang/origin/selCargoOriginG`;
        return axios.post(url, json, {headers: {'X-Merchant-Token': s.state.token}}).then(res => res.data);
    },
    selWarehouseG(json) {
        let url = localStorage.getItem("cang.base.url") + `/cang/warehouse/selWarehouseG`;
        return axios.post(url, json, {headers: {'X-Merchant-Token': s.state.token}}).then(res => res.data);
    },
    selCargoProcessP(json) {
        let url = localStorage.getItem("cang.base.url") + `cang/sys/cargoProcess/selCargoProcessP`;
        return axios.post(url, json, {headers: {'X-Merchant-Token': s.state.token}}).then(res => res.data);
    },
    selWaregouseStoreG(json) {
        let url = localStorage.getItem("cang.base.url") + `cang/warehousestore/selWaregouseStoreG`;
        return axios.post(url, json, {headers: {'X-Merchant-Token': s.state.token}}).then(res => res.data);
    },
    selCargoMaterialProcessG(json) {
        let url = localStorage.getItem("cang.base.url") + `cang/sys/cargoProcess/selCargoMaterialProcessG`;
        return axios.post(url, json, {headers: {'X-Merchant-Token': s.state.token}}).then(res => res.data);
    },
    selCargoOriginProcessG(json) {
        let url = localStorage.getItem("cang.base.url") + `cang/sys/cargoProcess/selCargoOriginProcessG`;
        return axios.post(url, json, {headers: {'X-Merchant-Token': s.state.token}}).then(res => res.data);
    },
    selSurfaceNameG(json) {
        let url = localStorage.getItem("cang.base.url") + `cang/sys/tolerance/selSurfaceNameG`;
        return axios.post(url, json, {headers: {'X-Merchant-Token': s.state.token}}).then(res => res.data);
    },
    selProcessG(json) {
        let url = localStorage.getItem("cang.base.url") + `cang/sys/process/selProcessG`;
        return axios.post(url, json, {headers: {'X-Merchant-Token': s.state.token}}).then(res => res.data);
    },
    selJGOutNotifyPForWechat(router, json) {
        let url = router + `cang/jgoutnotify/selJGOutNotifyPForWechat`;
        return axios.post(url, json, {headers: {'X-Merchant-Token': s.state.token}}).then(res => res.data);
    },
    selMachineNameG(json) {
        let url = localStorage.getItem("cang.base.url") + `cang/sys/machine/selMachineNameG`;
        return axios.post(url, json, {headers: {'X-Merchant-Token': s.state.token}}).then(res => res.data);
    },
    selMachineDetailNameG(json) {
        let url = localStorage.getItem("cang.base.url") + `cang/sys/machine/selMachineDetailNameG`;
        return axios.post(url, json, {headers: {'X-Merchant-Token': s.state.token}}).then(res => res.data);
    },
    selWarehouseAreaG(json) {
        let url = localStorage.getItem("cang.base.url") + `/cang/warehousearea/selWarehouseAreaG`;
        return axios.post(url, json, {headers: {'X-Merchant-Token': s.state.token}}).then(res => res.data);
    },
    selWarehousePositionG(json) {
        let url = localStorage.getItem("cang.base.url") + `/ang/warehousepos/selWarehousePositionG`;
        return axios.post(url, json, {headers: {'X-Merchant-Token': s.state.token}}).then(res => res.data);
    },
    searchCurrentStorageTotal(json) {
        let url = localStorage.getItem("cang.base.url") + `/cang/currentAnalysis/searchCurrentStorageTotal`;
        return axios.post(url, json, {headers: {'X-Merchant-Token': s.state.token}}).then(res => res.data);
    },
    searchJgInstockDetail(json) {
        let url = localStorage.getItem("cang.base.url") + `/cang/JgAnalysis/searchJgInstockDetail`;
        return axios.post(url, json, {headers: {'X-Merchant-Token': s.state.token}}).then(res => res.data);
    },
    searchJgInstockTotal(json) {
        let url = localStorage.getItem("cang.base.url") + `/cang/JgAnalysis/searchJgInstockTotalForWechat`;
        return axios.post(url, json, {headers: {'X-Merchant-Token': s.state.token}}).then(res => res.data);
    },
    searchJgInstockDetailByInstockId(json) {
        let url = localStorage.getItem("cang.base.url") + `/cang/JgAnalysis/searchJgInstockDetailByInstockIdForWechat`;
        return axios.post(url, json, {headers: {'X-Merchant-Token': s.state.token}}).then(res => res.data);
    },
    searchJgOutstockDetailByOutnotifyId(json) {
        let url = localStorage.getItem("cang.base.url") + `/cang/JgAnalysis/searchJgOutstockDetailByOutnotifyIdForWechat`;
        return axios.post(url, json, {headers: {'X-Merchant-Token': s.state.token}}).then(res => res.data);
    },
    searchJgOutInstockDetail(json) {
        let url = localStorage.getItem("cang.base.url") + `/cang/JgAnalysis/searchJgOutInstockDetail`;
        return axios.post(url, json, {headers: {'X-Merchant-Token': s.state.token}}).then(res => res.data);
    },
    searchJgOutInstockTotal(json) {
        let url = localStorage.getItem("cang.base.url") + `/cang/JgAnalysis/searchJgOutInstockTotalForWechat`;
        return axios.post(url, json, {headers: {'X-Merchant-Token': s.state.token}}).then(res => res.data);
    },
    selJgProcesstask(json) {
        let url = localStorage.getItem("cang.base.url") + `/cang/JgAnalysis/selJgProcesstask`;
        return axios.post(url, json, {headers: {'X-Merchant-Token': s.state.token}}).then(res => res.data);
    },
    searchJgInstockSumData(json) {
        let url = localStorage.getItem("cang.base.url") + `/cang/JgAnalysis/searchJgInstockSumData`;
        return axios.post(url, json, {headers: {'X-Merchant-Token': s.state.token}}).then(res => res.data);
    },
    searchJgOutInstockSumData(json) {
        let url = localStorage.getItem("cang.base.url") + `/cang/JgAnalysis/searchJgOutInstockSumData`;
        return axios.post(url, json, {headers: {'X-Merchant-Token': s.state.token}}).then(res => res.data);
    },
    selJgProcesstaskSumData(json) {
        let url = localStorage.getItem("cang.base.url") + `/cang/JgAnalysis/selJgProcesstaskSumData`;
        return axios.post(url, json, {headers: {'X-Merchant-Token': s.state.token}}).then(res => res.data);
    },

    selCurrentStorageSum(json) {
        let url = localStorage.getItem("cang.base.url") + `/cang/currentAnalysis/selCurrentStorageSum`;
        return axios.post(url, json, {headers: {'X-Merchant-Token': s.state.token}}).then(res => res.data);
    },

    searchInstockTotal(json) {
        let url = localStorage.getItem("cang.base.url") + `/cang/currentAnalysis/searchInstockTotal`;
        return axios.post(url, json, {headers: {'X-Merchant-Token': s.state.token}}).then(res => res.data);
    },
    selCurrentStockByProcessTotal(json) {
        let url = localStorage.getItem("cang.base.url") + `process/current/selCurrentStockByProcessTotal`;
        return axios.post(url, json, {headers: {'X-Merchant-Token': s.state.token}}).then(res => res.data);
    },
    selPackageCurStock(json) {
        let url = localStorage.getItem("cang.base.url") + `/process/in/selPackageCurStock`;
        return axios.post(url, json, {headers: {'X-Merchant-Token': s.state.token}}).then(res => res.data);
    },
    selProductCurStock(json) {
        let url = localStorage.getItem("cang.base.url") + `/process/in/selProductCurStock`;
        return axios.post(url, json, {headers: {'X-Merchant-Token': s.state.token}}).then(res => res.data);
    },
    selJgCurStock(json) {
        let url = localStorage.getItem("cang.base.url") + `/process/in/selJgCurStock`;
        return axios.post(url, json, {headers: {'X-Merchant-Token': s.state.token}}).then(res => res.data);
    },
    selCurrentStockByProcess(json) {
        let url = localStorage.getItem("cang.base.url") + `process/current/selCurrentStockByProcess`;
        return axios.post(url, json, {headers: {'X-Merchant-Token': s.state.token}}).then(res => res.data);
    },


    selOutstockTotal(json) {
        let url = localStorage.getItem("cang.base.url") + `/cang/currentAnalysis/selOutstockTotal`;
        return axios.post(url, json, {headers: {'X-Merchant-Token': s.state.token}}).then(res => res.data);
    },

    selTransferP(json) {
        let url = localStorage.getItem("cang.base.url") + `/cang/currentAnalysis/selTransferP`;
        return axios.post(url, json, {headers: {'X-Merchant-Token': s.state.token}}).then(res => res.data);
    },


    selLadOutnotifyListP(json) {
        let url = `${_deliverBaseUrl}outnotify/selLadOutnotifyListP`;
        return axios.post(url, json).then(res => res.data);
    },


    selLadOutnotifyByAllId(json) {
        let url = `${_deliverBaseUrl}outnotify/selLadOutnotifyByAllId`;
        return axios.post(url, json).then(res => res.data);
    },
    selJgProcessnotify(json) {
        let url = localStorage.getItem("cang.base.url") + `/cang/JgAnalysis/selJgProcessnotify`;
        return axios.post(url, json, {headers: {'X-Merchant-Token': s.state.token}}).then(res => res.data);
    },
    selNewsG(url,json) {
        let urlFinal = url + `/cang/sys/news/selNewsG`;
        return axios.post(urlFinal, json, {headers: {'X-Merchant-Token': s.state.token}}).then(res => res.data);
    },
    selNewsByIDG(url,json) {
        let urlFinal = url + `/cang/sys/news/selNewsByIDG`;
        return axios.post(urlFinal, json, {headers: {'X-Merchant-Token': s.state.token}}).then(res => res.data);
    },
    seltmsOrderPlanP(json) {
        let url = localStorage.getItem("cang.base.url") + `/cang/tmsReceive/seltmsOrderPlanP`;
        return axios.post(url, json, {headers: {'X-Merchant-Token': s.state.token}}).then(res => res.data);
    },
    seltmsOrderPlanByID(json) {
        let url = localStorage.getItem("cang.base.url") + `/cang/tmsReceive/seltmsOrderPlanByID`;
        return axios.post(url, json, {headers: {'X-Merchant-Token': s.state.token}}).then(res => res.data);
    },
    selCustomerReceiveP(json) {
        let url = localStorage.getItem("cang.base.url") + `/cang/JgAnalysis/selCustomerReceiveP`;
        return axios.post(url, json, {headers: {'X-Merchant-Token': s.state.token}}).then(res => res.data);
    },
    addCustomerReceive(json) {
        let url = localStorage.getItem("cang.base.url") + `/cang/JgAnalysis/addCustomerReceive`;
        return axios.post(url, json, {headers: {'X-Merchant-Token': s.state.token}}).then(res => res.data);
    },
    addtmsOrderPlan(json) {
        let url = localStorage.getItem("cang.base.url") + `/cang/tmsReceive/addtmsOrderPlan`;
        return axios.post(url, json, {headers: {'X-Merchant-Token': s.state.token}}).then(res => res.data);
    },
    delCustomerReceive(json) {
        let url = localStorage.getItem("cang.base.url") + `/cang/JgAnalysis/delCustomerReceive`;
        return axios.post(url, json, {headers: {'X-Merchant-Token': s.state.token}}).then(res => res.data);
    },
    updCustomerReceive(json) {
        let url = localStorage.getItem("cang.base.url") + `/cang/JgAnalysis/updCustomerReceive`;
        return axios.post(url, json, {headers: {'X-Merchant-Token': s.state.token}}).then(res => res.data);
    },
    updtmsOrderPlan(json) {
        let url = localStorage.getItem("cang.base.url") + `/cang/tmsReceive/updtmsOrderPlan`;
        return axios.post(url, json, {headers: {'X-Merchant-Token': s.state.token}}).then(res => res.data);
    },
    deltmsOrderPlan(json) {
        let url = localStorage.getItem("cang.base.url") + `/cang/tmsReceive/deltmsOrderPlan`;
        return axios.post(url, json, {headers: {'X-Merchant-Token': s.state.token}}).then(res => res.data);
    },
    submittmsOrderPlan(json) {
        let url = localStorage.getItem("cang.base.url") + `/cang/tmsReceive/submittmsOrderPlan`;
        return axios.post(url, json, {headers: {'X-Merchant-Token': s.state.token}}).then(res => res.data);
    },
    submittmsOrderPlanByCancel(json) {
        let url = localStorage.getItem("cang.base.url") + `/cang/tmsReceive/submittmsOrderPlanByCancel`;
        return axios.post(url, json, {headers: {'X-Merchant-Token': s.state.token}}).then(res => res.data);
    },
    confirmtmsOrderPlan(json) {
        let url = localStorage.getItem("cang.base.url") + `/cang/tmsReceive/confirmtmsOrderPlan`;
        return axios.post(url, json, {headers: {'X-Merchant-Token': s.state.token}}).then(res => res.data);
    },
    selJgProcesstaskP(json) {
        let url = localStorage.getItem("cang.base.url") + `/cang/JgAnalysis/selJgProcesstaskPForWechat`;
        return axios.post(url, json, {headers: {'X-Merchant-Token': s.state.token}}).then(res => res.data);
    },

    selJgProcesstaskByNotifyId(json) {
        let url = localStorage.getItem("cang.base.url") + `/cang/JgAnalysis/selJgProcesstaskByNotifyId`;
        return axios.post(url, json, {headers: {'X-Merchant-Token': s.state.token}}).then(res => res.data);
    },
    selRawMaterialListById(json) {
        let url = localStorage.getItem("cang.base.url") + `/cang/JgAnalysis/selRawMaterialListById`;
        return axios.post(url, json, {headers: {'X-Merchant-Token': s.state.token}}).then(res => res.data);
    },
    selProductListByTaskId(json) {
        let url = localStorage.getItem("cang.base.url") + `/cang/JgAnalysis/selProductListByTaskId`;
        return axios.post(url, json, {headers: {'X-Merchant-Token': s.state.token}}).then(res => res.data);
    },

    selProductByTaskId(json) {
        let url = localStorage.getItem("cang.base.url") + `/cang/JgAnalysis/selProductByTaskId`;
        return axios.post(url, json, {headers: {'X-Merchant-Token': s.state.token}}).then(res => res.data);
    },
    selPackageByTaskId(json) {
        let url = localStorage.getItem("cang.base.url") + `/cang/JgAnalysis/selPackageByTaskId`;
        return axios.post(url, json, {headers: {'X-Merchant-Token': s.state.token}}).then(res => res.data);
    },

    getAuthentication(router,token, json) {
        let url = router + `/cang/tencent/getAuthentication`;
        return axios.post(url, json, {headers: {}}).then(res => res.data);
    },
    killAuthentication(router,token, json) {
        let url = router + `/cang/tencent/killAuthentication`;
        return axios.post(url, json, {headers: {'X-Merchant-Token': token}}).then(res => res.data);
    },

    getCosCredential(router,token, json) {
        let url = router + `/cang/tencent/getCosCredential`;
        return axios.post(url, json, {headers: {'X-Merchant-Token': token}}).then(res => res.data);
    },

    addOutOrderImageG(router, json) {
        let url = router + `/cang/crmoutnotify/addOutOrderImageG`;
        return axios.post(url, json).then(res => res.data);
    },

}
